import {
  LOAD_PRODUCT,
  LOAD_PRODUCT_ERROR,
  LOAD_PRODUCT_SUCCESS,
} from '../constants/product';

export const LoadProduct = id => ({
  type: LOAD_PRODUCT,
  id,
});

export const LoadProductError = error => ({
  type: LOAD_PRODUCT_ERROR,
  error,
});

export const LoadProductSuccess = payload => ({
  type: LOAD_PRODUCT_SUCCESS,
  payload,
});
